export interface TypePrice {
  amount: number;
  currency: string;
}

export interface TypeFeature {
  description: string;
  infoDescription?: string;
  more: boolean;
}

export interface TypeCycle {
  monthsPerCycle: number;
  unit: string;
  count: number;
  price: number;
  priceWithTax: number;
  isEnabled: boolean;
  name: string;
  savePercentage?: number;
  saveTotalAmount?: number;
  discountedPrice?: number;
  discountedPriceWithTax?: number;
}

export interface TypeProductKey {
  productId: string;
}

export interface TypeProduct extends TypeProductKey {
  name: string;
  price: number;
  priceWithTax: number;
  isEnabled: boolean;
  discountedPrice?: number;
  discountedPercentage?: number;
  cycles: TypeCycle[];
  productLimitations: TypeProductLimitations;
}

export interface TypeCurrentSubscription extends TypeProductKey {
  subscriptionId: string;
  isBundled: boolean;
  productIndex: number;
  cycleIndex: number;
}

export enum TaxTypes {
  VAT = 'VAT',
  GST = 'GST',
}

export interface TypeCurrency {
  symbol: string;
  minorUnits: number;
  decimalSeparator: string;
  groupSeparator: string;
  negativePrefix: string;
  negativeSuffix: string;
  positivePrefix: string;
  positiveSuffix: string;
  taxType?: TaxTypes;
}

export const defaultTypeCurrency = {
  minorUnits: 0,
  decimalSeparator: '.',
  groupSeparator: ',',
  negativePrefix: '-¤',
  negativeSuffix: '',
  positivePrefix: '¤',
  positiveSuffix: '¤',
  symbol: 'US&#36;',
};

export interface TypeLocal {
  code: string;
}

export const defaultTypeLocal = {
  code: 'en',
};

export interface TypeClientOffer {
  products: TypeProduct[];
  currentProduct?: TypeCurrentSubscription;
  currency: TypeCurrency;
  local: TypeLocal;
}

export interface TypeSelectedOffer {
  metaSiteId?: string;
  productId?: string;
  productName?: string;
  currentProduct?: TypeCurrentSubscription;
}

export interface TypeProductLimitations {
  emailsCampaignsMonth: string;
  emailsSendMonth: string;
  formsMonth: string;
  automations: string;
  socialPosts: string;
  videoCreation: string;
  paymentRecurring: string;
  siteContributors: string;
  UNLIMITED: string;
}
